import React from 'react';
import cn from 'classnames';
import { CSSTransition } from 'react-transition-group';

import css from './Preloader.module.scss';

interface Props {
  className?: string;
  visible: boolean;
}

export default function Preloader({ visible, className = '' }: Props) {
  const nodeRef = React.useRef<HTMLDivElement>(null);
  return (
    <CSSTransition
      classNames={{
        enter: css.opacityAnimEnter,
        enterActive: css.opacityAnimEnterActive,
        exit: css.opacityAnimExit,
        exitActive: css.opacityAnimExitActive,
      }}
      in={visible}
      unmountOnExit
      timeout={300}
      nodeRef={nodeRef}
    >
      <div ref={nodeRef} className={cn(css.preloaderWrapper, css[className])}>
        <div className={css.thinkingDots}>
          <span className={css.thinkingDot} />
          <span className={css.thinkingDot} />
          <span className={css.thinkingDot} />
        </div>
      </div>
    </CSSTransition>
  );
}
